module.exports = __webpack_public_path__ + "img/checkupReport.694e79ed.png";